export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14654.f0aa220c.jpg";